module.exports = __webpack_public_path__ + "img/Send-money-1.daab6cc0.png";